import './Payment.css';
import ApartmentsApi from '../../services/apartments'
import {
    Box,
    Grid,
    Typography,
    CircularProgress,
    ListItem,
} from '@material-ui/core'
import ApplicationsApi from '../../services/applications'
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next'
import Suggest from '../Apartment/Stepper/Steps/Suggest'
import { useHistory } from 'react-router-dom'
import Button from '@material-ui/core/Button';
import { useParams } from 'react-router-dom';
import UsersApi from '../../services/users'

type PaymentPopupProps = {
    productTag: string;
    headertext: string
    infotext: React.ReactNode;
    apartment: any;
    application?: any,
    paymentProviderWidth?: string;
    contract?: any;
};

export default function PaymentPopup({ productTag, infotext, headertext, apartment, application, paymentProviderWidth, contract }: PaymentPopupProps) {
    const { t } = useTranslation();
    const [product, setProduct] = useState(null);
    const [paymentProviders, setPaymentProviders] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [showPaymentMethods, setShowPaymentMethods] = useState(false);
    const [totalPriceInEuros, setTotalPriceInEuros] = useState(0);
    const history = useHistory(); // React Router navigation hook
    const [couponCode, setCouponCode] = useState('');
    const [couponErrorMessage, setCouponErrorMessage] = useState<string | null>(null);
    const [couponSuccessMessage, setCouponSuccessMessage] = useState<string | null>(null);
    const [couponApplied, setCouponApplied] = useState(false);
    const { apartmentId, userId } = useParams<RouteParams>();

    type RouteParams = {
        apartmentId: string
        userId: string
    };

    useEffect(() => {
        window.history.pushState(null, "", window.location.href);

        const handleBackButton = (event) => {
            // history.push(`/users/${apartment.userId}/apartments/${apartment.apartmentId}/overview`);
            window.location.reload()
        };

        window.addEventListener("popstate", handleBackButton);

        return () => {
            window.removeEventListener("popstate", handleBackButton);
        };
    }, [history]);

    const getProduct = async () => {
        setIsLoading(true);
        try {
            console.log("getting product")
            const response = await ApartmentsApi.getProducts([productTag]);

            if (response?.products?.length > 0) {
                setProduct(response.products[0]);
                setTotalPriceInEuros(response.products[0].priceInEuros);
                await paymentHandler(response.products[0].priceInEuros * 100, response.products[0]);
            }
        } catch (error) {
            console.error('Error fetching products:', error);
        } finally {
            setIsLoading(false);
        }
    };

    async function paymentHandler(priceInCents, product) {
        try {
            setIsLoading(true);
            const selectedProducts = [product.productId];

            if (application) {
                selectedProducts.push({ applicationCode: application.code });
            }

            const apartmentInfo = {
                userId: apartment.userId,
                apartmentId: apartment.apartmentId,
                apartmentCode: apartment.code,
                publishCostInCents: priceInCents,
                selectedProducts,
                ...(contract && { contract: contract })
            };

            const paymentResponse = await ApplicationsApi.initiatePaymentForPublish(apartmentInfo);
            const filteredResponse = {
                ...paymentResponse,
                providers: paymentResponse.providers?.filter(method => method.id !== 'amex' && method.id !== 'apple-pay' && method.id !== 'nordea-business' && method.id !== 'siirto') || []
            };
            setShowPaymentMethods(true);
            setPaymentProviders(filteredResponse || null)
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }

    async function handleCoupon(couponCode: string, useCase: string) {

        // Reset messages when attempting again
        setIsLoading(true);
        setCouponErrorMessage(null);
        setCouponSuccessMessage(null);

        if (couponCode.length < 4) {
            setCouponErrorMessage(t('paymentPage.couponCodeTooShort'));
            setIsLoading(false);
            return;
        }

        try {
            const couponResponse = await ApplicationsApi.handlePaymentCoupon(couponCode, userId, useCase);

            if (couponResponse && couponResponse.status === 'valid') {
                const discount = couponResponse.discountPercentage / 100;
                const newPrice = totalPriceInEuros * (1 - discount);

                setCouponApplied(true);
                setTotalPriceInEuros(newPrice);
                //setCouponSuccessMessage(t('paymentPage.couponAppliedSuccessfully')); // New message for successful coupon application

                if (newPrice <= 0) {
                    //setShowPaymentMethods(false);
                    freeOfChargeFunction()
                } else {
                    setShowPaymentMethods(true);
                    //rentalPaymentHandler();  // Call the function to reinitialize the payment methods with the new price
                }
            } else if (couponResponse && couponResponse.status === 'failed') {
                if (couponResponse.message === 'Coupon not found') {
                    setCouponErrorMessage(t('paymentPage.couponNotFound'));
                } else if (couponResponse.message === 'Wrong use case') {
                    setCouponErrorMessage(t('paymentPage.couponWrongUseCase'));
                } else if (couponResponse.message === 'Coupon has expired') {
                    setCouponErrorMessage(t('paymentPage.couponExpired'));
                } else if (couponResponse.message === 'Coupon already used') {
                    setCouponErrorMessage(t('paymentPage.couponAlreadyUsed'));
                } else {
                    // Handle other unexpected messages
                    setCouponErrorMessage(t('paymentPage.couponNotFound'));
                }
                setIsLoading(false);
            }
        } catch (error) {
            console.error(error);
        } finally {
            
        }
    }

    async function freeOfChargeFunction() {
        // Reset messages when attempting again        
        // if (!isChecked) {
        //     setShowCheckboxError(true); // Show error if button is clicked without checking
        // } else {
        setIsLoading(true);
        //setShowCheckboxError(false);
        //console.log(product);
        
        try {
            await ApplicationsApi.addRights(application, product);

            //dispatch(navigate(`/apartments?status=ok`));

            const coupons: { couponCode: string } = {
                couponCode
            };
            try {
                const response = await UsersApi.updateUserUsedCoupons(userId, coupons)
                //dispatch(navigate(`/apartments?status=ok`));
                const url = new URL(window.location.href)
                url.searchParams.set('status', 'showCreditInfoOk')
                window.location.href = url.toString()
            } catch (error) {
                console.error(error);
            }

        } catch (error) {
            console.error(error)
        }
        //setIsLoading(false);
        //}
    }

    useEffect(() => {
        getProduct();
    }, []);

    return (
        <div className="flex items-center justify-center h-40 bg-gray-200 rounded-lg container-popup">
            <Grid container direction="row" justifyContent="space-evenly">
                <Grid container>
                    <Grid item xs={12}>
                        <div className="text-center">
                            <h1 style={{ margin: 0 }}>{headertext}</h1>
                            <Suggest
                                content={infotext}
                                containerMaxWidth="1550px"
                                contentMaxWidth="1450px"
                                isModal
                                padding="12px 0 15px 0"
                            />
                        </div>

                        {!isLoading ? (
                            product && (
                                <ListItem
                                    divider
                                    style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        padding: "12px",
                                        width: "100%",
                                        height: "56px",
                                        backgroundColor: "#FCF3F5",
                                        borderRadius: "12px",
                                        margin: "8px 0px",
                                        boxSizing: "border-box",
                                    }}
                                >
                                    <Box
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center",
                                            gap: "12px",
                                            marginLeft: "8px",
                                        }}
                                    >
                                        {/* Bolded 'selectedProduct' translation + Non-bolded Product Name */}
                                        <Typography style={{ fontSize: "14px", fontWeight: "700", color: "#2F2F2F" }}>
                                            {t("paymentPopup.selectedProduct")}
                                        </Typography>
                                        <Typography style={{ fontSize: "14px", fontWeight: "450", color: "#2F2F2F" }}>
                                            {t(`paymentPopup.productNames.${product.name}`)}
                                        </Typography>
                                    </Box>

                                    <Box
                                        style={{
                                            width: "81px",
                                            height: "32px",
                                            background: "#94004A",
                                            borderRadius: "8px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <Typography style={{ fontSize: "16px", fontWeight: "700", color: "#F7F8F9", textAlign: "center" }}>
                                            {
                                                totalPriceInEuros === 0
                                                    ? '0 €'
                                                    : product.priceInEuros === 0
                                                        ? t('paymentPage.freeOfCharge')
                                                        : product.priceInEuros % 1 === 0
                                                            ? `${product.priceInEuros},00 €`
                                                            : product.priceInEuros.toFixed(2).replace('.', ',') + ' €'
                                            }
                                        </Typography>
                                    </Box>
                                </ListItem>
                            )
                        ) : (
                            <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                                <CircularProgress size={72} style={{ color: '#94004A', margin: '25px' }} />
                            </div>
                        )}

                        {showPaymentMethods && paymentProviders && !isLoading && (
                            <div className="popupPaymentOptionMargins">
                                <div className="paymentOption">
                                    {paymentProviders.providers.map((provider) => (
                                        <form
                                            method="POST"
                                            action={provider.url}
                                            key={provider.id}
                                            className="paymentCard"
                                            onSubmit={(event) => {
                                                event.preventDefault();
                                                event.currentTarget.submit();
                                            }}
                                        >
                                            {provider.parameters.map((param) => (
                                                <input key={param.name} type="hidden" name={param.name} value={param.value} />
                                            ))}
                                            <button className="paymentProvider" style={paymentProviderWidth ? { width: paymentProviderWidth } : undefined}>
                                                <img
                                                    style={{ objectFit: 'contain', width: '80%' }}
                                                    src={provider.svg}
                                                    alt={provider.value}
                                                />
                                            </button>
                                        </form>
                                    ))}
                                </div>
                                {productTag === "showCreditInfo" && (
                                    <Grid container spacing={2} alignItems="center" className="gridContainer">
                                        <Grid item xs={12} md={12}>
                                            {!couponApplied && (
                                                <form
                                                    className={`couponForm`}
                                                    onSubmit={(event) => {
                                                        event.preventDefault();
                                                        // Handle coupon validation here.
                                                        handleCoupon(couponCode, "showCreditInfo");
                                                    }}
                                                >
                                                    <input
                                                        type="text"
                                                        placeholder={t('paymentPage.insertCouponCode')}
                                                        onChange={(e) => {
                                                            setCouponCode(e.target.value);
                                                        }}
                                                        className={`couponInput`}
                                                        style={{
                                                            // width: 'calc(100% - 170px)',

                                                        }}
                                                    />
                                                    <Button type="submit" variant="contained" color="primary" className={`couponButton`}
                                                        style={{
                                                            height: '3.05rem',
                                                            paddingLeft: '25px',
                                                            paddingRight: '25px',
                                                        }}>
                                                        {t('paymentPage.applyCoupon')}
                                                    </Button>
                                                </form>
                                            )}
                                            {couponErrorMessage && (
                                                <Typography
                                                    variant='body1'
                                                    className={`couponForm errorText couponMessage`}
                                                >
                                                    {couponErrorMessage}
                                                </Typography>
                                            )}
                                        </Grid>
                                    </Grid>
                                )}
                                <p style={{ textAlign: 'center', marginTop: '2rem' }}>
                                    {t('paymentPage.paymentTermsDisclaimerTextPart')}{' '}
                                    <a
                                        style={{ color: '#94004A', textDecoration: 'none', fontWeight: 'bold' }}
                                        href="https://www.leea.fi/kayttoehdot"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        {t('paymentPage.paymentTermsDisclaimerLinkPart')}
                                    </a>
                                </p>
                            </div>
                        )}
                        {couponSuccessMessage && (
                            <Typography
                                variant='body1'
                                className={`couponForm successText couponMessage`}
                            >
                                {couponSuccessMessage}
                            </Typography>
                        )}
                        {showPaymentMethods && !paymentProviders && (
                            <p className="centeredText heading my8">{t('paymentPage.paymentProvidersNotFound')}</p>
                        )}
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
}
